import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './dashboardGeral.css';

// Sistema de autenticação compartilhado
// import Navigation from './shared/routing/navigation.js';

// TEMPORARIAMENTE DESABILITADO para testar
// Navigation.checkAuthAndRedirect();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);